// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BehanceSquareOutlinedSvg from "@ant-design/icons-svg/es/asn/BehanceSquareOutlined";
import AntdIcon from '../components/AntdIcon';

var BehanceSquareOutlined = function BehanceSquareOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BehanceSquareOutlinedSvg
  }));
};

BehanceSquareOutlined.displayName = 'BehanceSquareOutlined';
export default React.forwardRef(BehanceSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/BehanceSquareOutlined.js
// module id = 635
// module chunks = 0